export default __webpack_public_path__ + "img/39e5db981fe683a1e20abc37aedec5f5.png";